import {
  Box,
  Button,
  CardHeader,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "../../../../components";

const CodigosFiscaisErrorDialog = ({
  open,
  setOpen,
  ncmInexistentes,
  cestInexistentes,
}) => {
  function onClose() {
    setOpen(false);
  }

  return (
    <Dialog fullWidth maxWidth={"sm"} open={open} onClose={onClose}>
      <CardHeader title="ERROS DE VALIDAÇÃO" className="m-2" />
      <DialogContent>
        {ncmInexistentes && ncmInexistentes.length > 0 && (
          <Box
            sx={{
              backgroundColor: "#c6282822",
              borderRadius: 2,
              padding: 2,
              marginBottom: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                mb: 1,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: "#000",
                }}
              >
                Códigos NCM inválidos
              </Typography>
              <i
                className="ph-bold ph-warning-circle"
                style={{ color: "#c62828", fontSize: 22 }}
              ></i>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                marginTop: 2,
                marginBottom: 1,
              }}
            >
              {ncmInexistentes.map((codigo, index) => (
                <Chip
                  key={index}
                  label={codigo}
                  style={{
                    backgroundColor: "#c62828",
                    color: "#FEE2E2",
                    fontWeight: 600,
                    fontSize: 13,
                    border: "1px solid #FECACA",
                  }}
                />
              ))}
            </Box>
          </Box>
        )}

        {cestInexistentes && cestInexistentes.length > 0 && (
          <Box
            sx={{
              backgroundColor: "#c6282822",
              borderRadius: 2,
              padding: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                mb: 1,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: "#000",
                }}
              >
                Códigos CEST inválidos
              </Typography>
              <i
                className="ph-bold ph-warning-circle"
                style={{ color: "#c62828", fontSize: 22 }}
              ></i>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                marginTop: 2,
                marginBottom: 1,
              }}
            >
              {cestInexistentes.map((codigo, index) => (
                <Chip
                  key={index}
                  label={codigo}
                  style={{
                    backgroundColor: "#c62828",
                    color: "#FEE2E2",
                    fontWeight: 600,
                    fontSize: 13,
                    border: "1px solid #FECACA",
                  }}
                />
              ))}
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          overflow: "auto",
          position: "sticky",
          bottom: 0,
          margin: 1,
          marginTop: 0,
          backgroundColor: "white",
        }}
      >
        <Button
          color="padrao"
          margin="normal"
          variant="contained"
          onClick={onClose}
          disableElevation
        >
          <i
            className="ph-fill ph-x-circle"
            style={{ fontSize: 22, marginRight: 10 }}
          ></i>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CodigosFiscaisErrorDialog;
